import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRouteError } from "react-router-dom";
export default function ErrorPage() {
    const error = useRouteError();
    return /*#__PURE__*/ _jsxs("div", {
        id: "error-page",
        children: [
            /*#__PURE__*/ _jsx("h1", {
                children: "Oops!"
            }),
            /*#__PURE__*/ _jsx("p", {
                children: "Sorry, an unexpected error has occurred."
            }),
            /*#__PURE__*/ _jsx("p", {
                children: /*#__PURE__*/ _jsx("i", {
                    children: error.message || 'Unknown error'
                })
            })
        ]
    });
}
